import { render, staticRenderFns } from "./BindsListItemExpand.vue?vue&type=template&id=4b2943be&"
import script from "./BindsListItemExpand.vue?vue&type=script&lang=js&"
export * from "./BindsListItemExpand.vue?vue&type=script&lang=js&"
import style0 from "./BindsListItemExpand.vue?vue&type=style&index=0&id=4b2943be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports